import { RefreshCwIcon } from 'lucide-react';

import { RetryDeployPeriod } from '@/react/edge/edge-stacks/components/RetryDeployPeriod';
import { RetryDeployToggle } from '@/react/edge/edge-stacks/components/RetryDeployToggle';

import { SwitchField } from '@@/form-components/SwitchField';
import { Card } from '@@/primitives/Card';

import { ArtifactConfig } from '../../types';

export function ComposeDeployOptions({
  values,
  setFieldValue,
}: {
  values: ArtifactConfig;
  setFieldValue: <K extends keyof ArtifactConfig>(
    f: K,
    v: ArtifactConfig[K]
  ) => void;
}) {
  return (
    <Card.Container>
      <Card.Header title="Deploy options" icon={RefreshCwIcon} />
      <Card.Body>
        <div className="form-group">
          <div className="col-sm-12">
            <SwitchField
              checked={values.prePullImage}
              name="prePullImage"
              label="Pre-pull images"
              tooltip="When enabled, the image will be pre-pulled before deployment is started. This is useful in scenarios where the image download may be delayed or intermittent and would subsequently cause the deployment to fail"
              labelClass="col-sm-3 col-lg-2"
              onChange={(value) => setFieldValue('prePullImage', value)}
              data-cy="pre-pull-images-switch"
            />
          </div>
        </div>

        <RetryDeployToggle
          onChange={(value) => setFieldValue('retryDeploy', value)}
          value={values.retryDeploy}
        />

        {values.retryDeploy && (
          <RetryDeployPeriod
            value={values.retryPeriod}
            onChange={(value) => setFieldValue('retryPeriod', value)}
          />
        )}
      </Card.Body>
    </Card.Container>
  );
}
